import React from 'react'

import { Display, Visible } from '@gousto-internal/citrus-react'

import { DesktopSearchRecipeTile } from './DesktopSearchRecipeTile'
import { MobileSearchRecipeTile } from './MobileSearchRecipeTile'
import type { MenuSearchRecipeProps } from './types'

export const MenuSearchRecipe = ({
  recipe,
  context,
  canAddRecipes,
  reachedLimit,
  isInBasket,
  isAuthenticated,
  quantity,
  onAddRecipe,
  onBlockedAddAttempt,
  onRecipeClick,
  onRemoveRecipe,
  renderFlexPortionControl,
}: MenuSearchRecipeProps) => {
  // Authenticated subtitle tags are already filtered by the Experience API. For
  // guests, preserve the legacy search design by showing only time and calories.
  const displayRecipe = isAuthenticated
    ? recipe
    : {
        ...recipe,
        tagGroups: {
          ...recipe.tagGroups,
          subtitle: recipe.tagGroups.subtitle?.filter(
            ({ type }) => type === 'cookingTime' || type === 'energy',
          ),
        },
      }
  const sharedProps = {
    recipe: displayRecipe,
    isInBasket,
    canAddRecipes,
    reachedLimit,
    onClick: () => onRecipeClick(recipe, context),
    onAddClick: () => onAddRecipe(recipe, context),
    onRemoveClick: () => onRemoveRecipe(recipe, context),
    onBlockedAddAttempt,
  }
  const desktopFlexPortionControl = isInBasket
    ? renderFlexPortionControl?.(recipe, context, 'desktop')
    : undefined
  const mobileFlexPortionControl = isInBasket
    ? renderFlexPortionControl?.(recipe, context, 'mobile')
    : undefined

  return (
    <>
      <Visible display={[Display.None, Display.Block]}>
        <DesktopSearchRecipeTile
          {...sharedProps}
          flexPortionControl={desktopFlexPortionControl}
          isAuthenticated={isAuthenticated}
        />
      </Visible>
      <Visible display={[Display.Block, Display.None]}>
        <MobileSearchRecipeTile
          {...sharedProps}
          flexPortionControl={mobileFlexPortionControl}
          quantity={quantity}
        />
      </Visible>
    </>
  )
}
